<template>
  <footer class="footer">
    <div class="footer-inner">
      <div class="footer-block">
        <h1>{{ $t('footerHeading') }}</h1>
        <p v-html="$t('footerAddress')"></p>
        <div class="footer-socials">
          <vue-goodshare-facebook
            page_url="https://radionica.digital"
            :page_title="$t('businessName')"
            :page_description="$t('businessIntro')"
            button_design="flat"
            has_icon
          ></vue-goodshare-facebook>
          <vue-goodshare-linkedIn
            page_url="https://radionica.digital"
            :page_title="$t('businessName')"
            :page_description="$t('businessIntro')"
            button_design="flat"
            has_icon
          ></vue-goodshare-linkedIn>
          <vue-goodshare-pinterest
            page_url="https://radionica.digital"
            :page_title="$t('businessName')"
            :page_description="$t('businessIntro')"
            button_design="flat"
            has_icon
          ></vue-goodshare-pinterest>
          <vue-goodshare-twitter
            page_url="https://radionica.digital"
            :page_title="$t('businessName')"
            :page_description="$t('businessIntro')"
            button_design="flat"
            has_icon
          ></vue-goodshare-twitter>
          <vue-goodshare-whatsApp
            page_url="https://radionica.digital"
            :page_title="$t('businessName')"
            :page_description="$t('businessIntro')"
            button_design="flat"
            has_icon
          ></vue-goodshare-whatsApp>
          <vue-goodshare-viber
            page_url="https://radionica.digital"
            :page_title="$t('businessName')"
            :page_description="$t('businessIntro')"
            button_design="flat"
            has_icon
          ></vue-goodshare-viber>
        </div>
      </div>
      <div class="footer-block">
        <h5>{{ $t('footerServiceHeading') }}</h5>
        <ul>
          <li>{{ $t('serviceOneTitle') }}</li>
          <li>{{ $t('serviceTwoTitle') }}</li>
          <li>{{ $t('serviceThreeTitle') }}</li>
        </ul>
      </div>
      <div class="footer-block">
        <h6>{{ $t('footerSocialHeading') }}</h6>
        <p><a :href="'mailto:' + $t('footerSocialEmail')">{{ $t('footerSocialEmail') }}</a></p>
      </div>
    </div>
    
    <hr>
    <p>&copy; 2017 - {{ year }}</p>
  </footer>
</template>

<script>
  import VueGoodshareFacebook from "vue-goodshare/src/providers/Facebook.vue";
  import VueGoodshareLinkedIn from "vue-goodshare/src/providers/LinkedIn.vue";
  import VueGoodsharePinterest from "vue-goodshare/src/providers/Pinterest.vue";
  import VueGoodshareTwitter from "vue-goodshare/src/providers/Twitter.vue";
  import VueGoodshareWhatsApp from "vue-goodshare/src/providers/WhatsApp.vue";
  import VueGoodshareViber from "vue-goodshare/src/providers/Viber.vue";
  export default {
    name: 'Footer',
    computed: {
      year () {
        return new Date().getFullYear();
      }
    },
    components: {
      VueGoodshareFacebook,
      VueGoodshareLinkedIn,
      VueGoodsharePinterest,
      VueGoodshareTwitter,
      VueGoodshareWhatsApp,
      VueGoodshareViber
    },
  }
</script>
<style scoped lang="scss">
  .footer {
    @apply flex flex-col pt-6 pb-6 items-center;
    position: relative;
    z-index: 2;
    .footer-inner {
      @apply flex pb-6 justify-between px-4 w-full;

      .footer-block {
        @apply flex-1;
        h1,
        h5,
        h6, {
          @apply font-bold leading-loose;
        }
        
        ul {
          list-style: disc;
          list-style-position: inside;
        }

        &:nth-child(2) {
          @apply text-center;
        }

        &:nth-child(3) {
          @apply text-right;
        }

        .footer-socials {
          @apply pt-3;
        }
      }
    }

    hr {
      @apply bg-dark;
      height: 1px;
      margin: 0px auto;
      padding: 0px;
      width: 123px;

      + p {
        padding-top: 10px;
        font-size: 11px;
      }
    }

    @screen lg {
      .footer-inner {
        .footer-block {
          h1,
          h5,
          h6, {
            @apply text-sm;
          }  
          ul {
            @apply text-sm;
          }

          p {
            @apply text-sm;
          }
        }
      }
    }
    @screen md {
      .footer-inner {
        .footer-block {
          h1,
          h5,
          h6, {
            @apply text-sm;
          }  
          ul {
            @apply text-sm;
          }

          p {
            @apply text-sm;
          }
        }
      }
    }
    @screen sm {
      @apply items-center;
      .footer-inner {
        @apply flex-col justify-center;
        .footer-block {
          @apply text-center pb-4;
          h1,
          h5,
          h6, {
            @apply text-sm;
          }  
          ul {
            @apply text-sm;
          }
          p {
            @apply text-sm;
          }
          &:nth-child(2) {
            @apply text-center;
          }

          &:nth-child(3) {
            @apply text-center;
          }
        }
      }
    }
    hr {
      width: 65px;
    }
  }
</style>